import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getUserAditionalTrackCourse } from 'store/course-actions';

import {
  getStatusLessons,
  getTrackLoadLesson,
  setFinishLesson,
  setStartLesson,
  setVideoHistory
} from 'store/lesson-actions';

import { getLinkLtik } from 'constants/LTIData';

import VideoInfo from 'components/UI/VideoInfo/VideoInfo';

const VideoLesson = props => {
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataLesson = useSelector(state => state.lessonInfo);
  const playerRef = useRef(null);
  const transcriptParam = 30;
  let timeTranscript = 0;
  const [audioPlayer, setAudioPlayer] = useState(false);
  const [hasCaption, setHasCaption] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = window.location.pathname.split('/');
    if (url[2] === 'aud' || url[3] === 'aud') {
      if (dataLesson.data.pathAudio) {
        setAudioPlayer(dataLesson.data.pathAudio);
      }
    }
    let caption = props.videoData.data.pathVtt.split('/');
    if (caption[3] !== 'null') {
      setHasCaption(true);
    }
    setLoading(false);
  }, []);

  const videoJsOptions = {
    autoplay: true,
    currentTime: 20,
    playbackRates: [0.5, 1, 1.5, 2],
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        src:
          audioPlayer.length > 0
            ? audioPlayer
            : props.videoData.data.hlsMedium
            ? props.videoData.data.hlsMedium
            : props.videoData.data.idRepo === 2
            ? `https://mayahii-partners.s3.amazonaws.com/${props.videoData.data.claveVideo}`
            : `https://d3g2ltadvcvug.cloudfront.net/${props.videoData.data.claveVideo}`
      }
    ]
  };

  const handlePlayerReady = player => {
    const timeToSave = 5;
    const porcentToEnd = 0.9;
    let flagEnd = false;
    let auxTime = 0;
    playerRef.current = player;

    player.on('ready', () => {
      props.playerTimeHandler(props.videoData.videoHistory);
      auxTime = props.videoData.videoHistory;
      timeTranscript = props.videoData.videoHistory;
      props.transcriptHandler(timeTranscript, transcriptParam);
      player.currentTime(props.videoData.videoHistory);
      auxTime = props.historyMedia;
      player.currentTime(props.historyMedia);
      dispatch(
        getTrackLoadLesson(
          props.idLesson,
          props.idCourse,
          dataAcademy.data.shortName
        )
      );
    });
    (async () => {
      await setStartLesson(
        props.idLesson,
        props.idCourse,
        dataAcademy.data.shortName,
        true
      );
    })();

    player.on('timeupdate', () => {
      props.playerTimeHandler(player.currentTime());
      let videoDuartion = props.videoData.data.duracion;
      let videoExtension = props.videoData.data.claveVideo;
      videoExtension = videoExtension.split('.');
      videoExtension = videoExtension[1];
      if (videoExtension !== 'mp4Mayahii1080p') {
        videoDuartion = videoDuartion / 1000;
      }
      if (player.currentTime() === 0) {
        player.currentTime(auxTime);
      }
      if (Math.abs(auxTime - player.currentTime()) > timeToSave) {
        auxTime = player.currentTime();
        if (auxTime < timeTranscript) {
          props.transcriptHandler(auxTime, transcriptParam);
          timeTranscript = auxTime + transcriptParam;
        }
        if (auxTime > timeTranscript) {
          props.transcriptHandler(auxTime, transcriptParam);
          timeTranscript = auxTime + transcriptParam;
        }
        dispatch(
          setVideoHistory(
            props.idLesson,
            parseInt(auxTime),
            dataAcademy.data.shortName
          )
        );
        if (player.currentTime() !== 0) {
          dispatch(
            setVideoHistory(
              props.idLesson,
              parseInt(auxTime),
              dataAcademy.data.shortName
            )
          );
        }
        props.changeVideoStatus(1);
      }

      if (
        !flagEnd &&
        player.currentTime() / videoDuartion > porcentToEnd
      ) {
        flagEnd = true;
        (async () => {
          const finishLesson = await setFinishLesson(
            props.idLesson,
            props.idCourse,
            dataAcademy.data.shortName,
            true
          );
          if (finishLesson) {
            dispatch(getUserAditionalTrackCourse(props.idCourse));
            if (getLinkLtik()) {
              var gradeOptions = {
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ debug: true }),
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + getLinkLtik()
                }
              };
              fetch(
                'https://lti13.mayahii.com/gradelti',
                gradeOptions
              )
                .then(response => response.json())
                .then(data => {
                  // Resultado de la llamda gradelti
                  console.log('data', data);
                });
            }
            dispatch(
              getStatusLessons(props.idCourse, props.idLesson)
            );
          }
        })();
      }
    });
  };

  return (
    !loading && (
      <VideoInfo
        options={videoJsOptions}
        onReady={handlePlayerReady}
        audioPlayer={audioPlayer}
        caption={props.videoData.data.pathVtt}
        hasCaption={hasCaption}
      />
    )
  );
};

VideoLesson.propTypes = {
  // eslint-disable-next-line react/require-default-props
  videoData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeVideoStatus: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  transcriptHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  playerTimeHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  historyMedia: PropTypes.number
};

export default VideoLesson;
